// Local storage helper functions
const NOTIFICATION_PREFERENCES_KEY = 'notification_preferences';

export const getNotificationPreferences = (): Record<string, boolean> => {
  try {
    const preferences = localStorage.getItem(NOTIFICATION_PREFERENCES_KEY);
    return preferences ? JSON.parse(preferences) : {};
  } catch (error) {
    console.error('Error reading notification preferences:', error);
    return {};
  }
};

export const setNotificationPreference = (
  id: string,
  hideNotification: boolean,
) => {
  try {
    const preferences = getNotificationPreferences();
    preferences[id] = hideNotification;
    localStorage.setItem(
      NOTIFICATION_PREFERENCES_KEY,
      JSON.stringify(preferences),
    );
  } catch (error) {
    console.error('Error saving notification preference:', error);
  }
};

export const shouldHideNotification = (id: string): boolean => {
  const preferences = getNotificationPreferences();
  return !!preferences[id];
};
